import React from 'react';

export default function AcademicsPage() {
  return (
    <>
      <div className="page-hero">
        <h2>Academics</h2>
        <p>A curriculum designed to inspire young curious minds</p>
      </div>
      <section style={{padding:'70px 0'}}>
        <div className="container">
          <div style={{textAlign:'center',marginBottom:'50px'}}>
            <div className="section-tag">Our Curriculum</div>
            <h2 className="section-title">Holistic Learning for Every Child</h2>
          </div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'24px',marginBottom:'60px'}}>
            {[
              {icon:'🔤', title:'Language & Literacy', desc:'Building strong communication skills through stories, rhymes, phonics and reading activities.'},
              {icon:'🔢', title:'Numeracy & Maths', desc:'Hands-on number activities, counting, shapes and basic mathematical concepts.'},
              {icon:'🌿', title:'Environmental Science', desc:'Exploring nature, living things and the world around us through observation and discovery.'},
              {icon:'🎨', title:'Art & Craft', desc:'Developing fine motor skills and creativity through drawing, painting and craft projects.'},
              {icon:'🎵', title:'Music & Rhymes', desc:'Songs, rhymes and rhythmic activities that develop listening, memory and expression.'},
              {icon:'🤸', title:'Physical Education', desc:'Outdoor activities, yoga and games that promote physical fitness and healthy habits.'},
            ].map((c,i) => (
              <div key={i} style={{background:'#fff',borderRadius:'16px',padding:'28px',border:'1px solid #eee',boxShadow:'0 2px 12px rgba(0,0,0,.05)'}}>
                <div style={{fontSize:'36px',marginBottom:'14px'}}>{c.icon}</div>
                <h3 style={{fontFamily:'Poppins',fontSize:'16px',fontWeight:'700',color:'var(--navy)',marginBottom:'10px'}}>{c.title}</h3>
                <p style={{fontSize:'13px',color:'#666',lineHeight:'1.7'}}>{c.desc}</p>
              </div>
            ))}
          </div>
          <div style={{background:'linear-gradient(135deg,#1a2d6b 0%,#0f1e4a 100%)',borderRadius:'20px',padding:'48px',color:'#fff',textAlign:'center'}}>
            <h3 style={{fontFamily:'Poppins',fontSize:'28px',fontWeight:'800',marginBottom:'14px'}}>Daily School Schedule</h3>
            <p style={{color:'rgba(255,255,255,.8)',marginBottom:'32px'}}>A well-structured day that balances learning, play and rest.</p>
            <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:'20px'}}>
              {[['9:30 AM','Assembly & Prayer'],['10:00 AM','Classroom Sessions'],['12:00 AM','Play & Activity Time'],['01:00 PM','Lunch & Rest']].map(([t,a]) => (
                <div key={t} style={{background:'rgba(255,255,255,.1)',borderRadius:'12px',padding:'20px',border:'1px solid rgba(255,255,255,.2)'}}>
                  <div style={{color:'#f5a623',fontWeight:'800',fontSize:'18px',marginBottom:'6px'}}>{t}</div>
                  <div style={{fontSize:'14px',color:'rgba(255,255,255,.9)'}}>{a}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
